<div class="PGNavTree border-end">
    <div class="list-group">
        @for (navElement of navList; track navElement; let i = $index) {
            @if (navElement.visible != null) {
                <div
                    class="list-group-item {{navElement.active ? 'active' : ''}} PGNavTree-Element {{navElement.type == 'directory' ? 'PGNavTree-Element--Directory' : ''}} {{navElement.type == 'split' ? 'PGNavTree-Element--Split' : ''}} {{ getChildType(i) ? 'PGNavTree-Element--IsChild' + getChildType(i) : ''}}"
                    appPgAnimations="{{navElement.visible ? 'EnterL' : 'ExitL'}}"
                    (click)="elementClick(navElement);">
                    <div [style.paddingLeft]="(navElement.level * 20) + 'px'">
                        @if (navElement.type != 'split') {
                            <span class="PGNavTree-Element-Icon">
                                @if (navElement.type != 'directory') {
                                    <i class="{{navElement.icon}}"></i>
                                }
                                @if (navElement.type == 'directory' && !navElement.expanded) {
                                    <i class="fa-regular fa-folder"></i>
                                }
                                @if (navElement.type == 'directory' && navElement.expanded) {
                                    <i class="fa-regular fa-folder-open"></i>
                                }
                            </span>
                            <span class="PGNavTree-Element-Name">{{navElement.name | locTranslate}}</span>
                        }
                    </div>
                </div>
            }
        }
    </div>
</div>
